/* eslint-disable */
import React, { ReactNode } from 'react';
import s from './FilterPopup.module.less';
import { Button, Space } from 'antd';
import { FilterHeaderComponentProps } from '../../filters';
import { CloseOutlined, SearchOutlined } from '@ant-design/icons';
import classNames from 'classnames';

type WrapperOrientation = 'column' | 'row';
type WrapperButtonStyle = 'normal' | 'mini';

interface Props<T extends unknown> extends FilterHeaderComponentProps<T> {
  orientation?: WrapperOrientation;
  buttonStyle?: WrapperButtonStyle;
  children: ReactNode;
  filterInputClassName?: string;
}

/**
 * Компонент-враппер. Добавляет кнопки "Найти" и "Сбросить".
 * Позволяет инициировать поиск либо сброс фильтра
 */
export function FilterWrapper<T>({
  children,
  onConfirm,
  onReset,
  filterInputClassName,
  orientation = 'column',
  buttonStyle = 'normal',
}: Props<T>) {
  const orientationClass = orientation === 'row' ? s.GridFilterPopupRowOrientation : undefined;
  const buttonWidthClass = buttonStyle === 'normal' ? s.FilterButtonNormal : undefined;

  const confirmButtonText = buttonStyle === 'normal' ? 'Найти' : null;

  const resetButtonIcon = buttonStyle === 'mini' ? <CloseOutlined /> : null;
  const resetButtonText = buttonStyle === 'normal' ? 'Сбросить' : null;

  return (
    <div className={classNames(s.GridFilterPopup, orientationClass)}>
      <div className={classNames(s.FilterInput, filterInputClassName)}>{children}</div>
      <Space className={s.FilterActions}>
        <Button type={'primary'} className={buttonWidthClass} onClick={() => onConfirm()} icon={<SearchOutlined />}>
          {confirmButtonText}
        </Button>
        <Button className={buttonWidthClass} onClick={onReset} icon={resetButtonIcon}>
          {resetButtonText}
        </Button>
      </Space>
    </div>
  );
}
